import { ButtonGroup } from '@sg/garnish';

import { type AddressType } from '../../address.config';
import { useAddressTypes } from '../../hooks';

export const AddressFormAddressType = (props: AddressFormAddressTypeProps) => {
  const { addressType, hasHomeAddress, hasWorkAddress, onChange } = props;

  const addressTypes = useAddressTypes({
    addressType,
    hasHomeAddress,
    hasWorkAddress,
  });

  return (
    <ButtonGroup
      fluid
      value={addressType}
      items={addressTypes}
      onChange={(value: string) => onChange(value as AddressType)}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type AddressFormAddressTypeProps = {
  addressType: AddressType;
  hasHomeAddress: boolean;
  hasWorkAddress: boolean;
  onChange: (type: AddressType) => void;
};
